import { Divider, message } from 'antd';
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import CancelButton from '../../components/CancelButton';
import Head from '../../components/Head';
import RegisterForm from '../../components/RegisterForm';
import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Radio from '../../components/UI/Radio';
import SelectInput from '../../components/UI/SelectInput';
import SwitchInput from '../../components/UI/SwitchInput';
import { createOrUpdateDistributor, getDistributorById, getDistributorImage, uploadDistributorImage } from '../../services/distributors';
import { notificationError } from '../../services/notification';
import { onlySpaces } from '../../utils/formValidation';
import { findRelativeStatus } from '../../utils/objectUtils';
import { onlyNumbersAsString, validateEmailsByComma } from '../../utils/stringUtils';
import { InputMode } from '../../enums/inputTypeEnum';
import { serverUrl } from '../../services/api';

function NewDistributor() {
  const history = useNavigate()
  const { id } = useParams()
  const statusSelectOptions = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Closed', value: 'CLOSED' },
    { label: 'Inactive', value: 'INACTIVE' }
  ]
  const [image, setImage] = useState<any>()
  const [form, setForm] = useState({
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: statusSelectOptions[0].value,
    disableDeckManagement: false,
    pinCode: "",
    mdorBusinessName: "",
    mdorEtin: "",
    mdorFein: "",
    mdorLicenseNumber: "",
    mdorPermitId: "",
    mdorContactFirstname: "",
    mdorContactLastname: "",
    mdorContactTitle: "",
    mdorContactPhone: "",
    mdorContactFax: "",
    mdorAddressLine1: "",
    mdorAddressLine2: "",
    mdorCity: "",
    mdorState: "",
    mdorZipcode: "",
    mdorEmail: "",
  })

  const [orig, setOrig] = useState({
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: statusSelectOptions[0].value,
    disableDeckManagement: false,
    pinCode: "",
    mdorBusinessName: "",
    mdorEtin: "",
    mdorFein: "",
    mdorLicenseNumber: "",
    mdorPermitId: "",
    mdorContactFirstname: "",
    mdorContactLastname: "",
    mdorContactTitle: "",
    mdorContactPhone: "",
    mdorContactFax: "",
    mdorAddressLine1: "",
    mdorAddressLine2: "",
    mdorCity: "",
    mdorState: "",
    mdorZipcode: "",
    mdorEmail: "",
  })

  const [preview, setPreview] = useState<any | null>(null)

  useEffect(() => {
    (async () => {
      if (id) {
        const response = await getDistributorById({ id: id })
        setForm({
          name: response.name,
          address: response.address,
          zipcode: response.zipcode,
          city: response.city,
          state: response.state,
          phone: response.phone,
          email: response.email,
          status: findRelativeStatus(response.status, statusSelectOptions),
          disableDeckManagement: response.disableDeckManagement,
          pinCode: response.pinCode,
          mdorBusinessName: response.mdorBusinessName,
          mdorEtin: response.mdorEtin,
          mdorFein: response.mdorFein,
          mdorLicenseNumber: response.mdorLicenseNumber,
          mdorPermitId: response.mdorPermitId,
          mdorContactFirstname: response.mdorContactFirstname,
          mdorContactLastname: response.mdorContactLastname,
          mdorContactTitle: response.mdorContactTitle,
          mdorContactPhone: response.mdorContactPhone,
          mdorContactFax: response.mdorContactFax,
          mdorAddressLine1: response.mdorAddressLine1,
          mdorAddressLine2: response.mdorAddressLine2,
          mdorCity: response.mdorCity,
          mdorState: response.mdorState,
          mdorZipcode: response.mdorZipcode,
          mdorEmail: response.mdorEmail
        })
        setOrig({
          name: response.name,
          address: response.address,
          zipcode: response.zipcode,
          city: response.city,
          state: response.state,
          phone: response.phone,
          email: response.email,
          status: findRelativeStatus(response.status, statusSelectOptions),
          disableDeckManagement: response.disableDeckManagement,
          pinCode: response.pinCode,
          mdorBusinessName: response.mdorBusinessName,
          mdorEtin: response.mdorEtin,
          mdorFein: response.mdorFein,
          mdorLicenseNumber: response.mdorLicenseNumber,
          mdorPermitId: response.mdorPermitId,
          mdorContactFirstname: response.mdorContactFirstname,
          mdorContactLastname: response.mdorContactLastname,
          mdorContactTitle: response.mdorContactTitle,
          mdorContactPhone: response.mdorContactPhone,
          mdorContactFax: response.mdorContactFax,
          mdorAddressLine1: response.mdorAddressLine1,
          mdorAddressLine2: response.mdorAddressLine2,
          mdorCity: response.mdorCity,
          mdorState: response.mdorState,
          mdorZipcode: response.mdorZipcode,
          mdorEmail: response.mdorEmail
        })
        if (response && response.image) setPreview(serverUrl + response.image)
      }
    })()
  }, [])

  const isChanged = () => {

    if(!form.name
        || !form.address
        || !form.zipcode
        || !form.city
        || !form.state
        || !form.phone
        || !form.email
        || !form.status
        || !form.pinCode
        || !form.mdorBusinessName
        || !form.mdorEtin
        || !form.mdorFein
        || !form.mdorLicenseNumber
        || !form.mdorPermitId
        || !form.mdorContactFirstname
        || !form.mdorContactLastname
        || !form.mdorContactTitle
        || !form.mdorContactPhone
        || !form.mdorContactFax
        || !form.mdorAddressLine1
        || !form.mdorAddressLine2
        || !form.mdorCity
        || !form.mdorState
        || !form.mdorZipcode
        || !form.mdorEmail
    ) return false
    if(form.address!==orig.address) return true
    if(form.name!==orig.name) return true
    if(onlyNumbersAsString(form.zipcode)!==onlyNumbersAsString(orig.zipcode)) return true
    if(form.city!==orig.city) return true
    if(form.state!==orig.state) return true
    if(onlyNumbersAsString(form.phone)!==onlyNumbersAsString(orig.phone)) return true
    if(form.email!==orig.email) return true
    if(form.state!==orig.state) return true
    if(form.status!==orig.status) return true
    if(form.disableDeckManagement!==orig.disableDeckManagement) return true
    if(form.pinCode!==orig.pinCode) return true
    if(form.mdorBusinessName!==orig.mdorBusinessName) return true
    if(form.mdorEtin!==orig.mdorEtin) return true
    if(form.mdorFein!==orig.mdorFein) return true
    if(form.mdorLicenseNumber!==orig.mdorLicenseNumber) return true
    if(form.mdorPermitId!==orig.mdorPermitId) return true
    if(form.mdorContactFirstname!==orig.mdorContactFirstname) return true
    if(form.mdorContactLastname!==orig.mdorContactLastname) return true
    if(form.mdorContactTitle!==orig.mdorContactTitle) return true
    if(form.mdorContactPhone!==orig.mdorContactPhone) return true
    if(form.mdorContactFax!==orig.mdorContactFax) return true
    if(form.mdorContactFax!==orig.mdorContactFax) return true
    if(form.mdorAddressLine1!==orig.mdorAddressLine1) return true
    if(form.mdorAddressLine2!==orig.mdorAddressLine2) return true
    if(form.mdorCity!==orig.mdorCity) return true
    if(form.mdorState!==orig.mdorState) return true
    if(form.mdorZipcode!==orig.mdorZipcode) return true
    if (preview && image) return true
    return form.mdorEmail !== orig.mdorEmail;

  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const objectUrl = URL.createObjectURL(e.target.files[0])
      setPreview(objectUrl)
      setImage(e.target.files[0])
    }
  }

  const submit = async () => {
    const { validEmails, invalidEmails } = validateEmailsByComma(form.email)
    const zipcode = onlyNumbersAsString(form.zipcode)
    const mdorZipcode = onlyNumbersAsString(form.mdorZipcode)
    if (!form.name || onlySpaces(form.name)) return notificationError('Please insert name')
    if (!form.address || onlySpaces(form.address)) return notificationError('Please insert address')
    if (!form.city || onlySpaces(form.city)) return notificationError('Please insert city')
    if (!form.state || onlySpaces(form.state)) return notificationError('Please insert a state')
    if (!form.phone) return notificationError('Please insert a phone')
    const phone = onlyNumbersAsString(form.phone)
    if(phone.length < 10 || phone.length > 10 ) return notificationError('Phone must be 10 numbers')
    if(zipcode.length < 5 || zipcode.length > 9 ) return notificationError('Zipcode must have between 5 and 9 characters and only numbers')
    if (validEmails === 0) return notificationError('Please insert a valid email')
    if (invalidEmails > 0) return notificationError('Please insert only valid emails')
    if (!form.pinCode || onlySpaces(form.pinCode)) return notificationError('Please insert a pin code')
    if (!form.mdorBusinessName || onlySpaces(form.mdorBusinessName)) return notificationError('Please insert a MDOR business name')
    if (!form.mdorEtin || onlySpaces(form.mdorEtin)) return notificationError('Please insert a MDOR Etin')
    if (!form.mdorFein || onlySpaces(form.mdorFein)) return notificationError('Please insert a MDOR fein')
    if (!form.mdorLicenseNumber || onlySpaces(form.mdorLicenseNumber)) return notificationError('Please insert a MDOR license number')
    if (!form.mdorPermitId || onlySpaces(form.mdorPermitId)) return notificationError('Please insert a MDOR permit ID')
    if (!form.mdorContactFirstname || onlySpaces(form.mdorContactFirstname)) return notificationError('Please insert a MDOR first name')
    if (!form.mdorContactLastname || onlySpaces(form.mdorContactLastname)) return notificationError('Please insert a MDOR last name')
    if (!form.mdorContactTitle || onlySpaces(form.mdorContactTitle)) return notificationError('Please insert a MDOR contact title')
    if (!form.mdorContactPhone || onlySpaces(form.mdorContactPhone)) return notificationError('Please insert a MDOR contact phone')
    if (!form.mdorContactFax || onlySpaces(form.mdorContactFax)) return notificationError('Please insert a MDOR contact fax')
    if (!form.mdorAddressLine1 || !form.mdorAddressLine2 || onlySpaces(form.mdorAddressLine1) || onlySpaces(form.mdorAddressLine2)) return notificationError('Please insert a MDOR contact address')
    if (!form.mdorCity || onlySpaces(form.mdorCity)) return notificationError('Please insert a MDOR city')
    if (!form.mdorState || onlySpaces(form.mdorState)) return notificationError('Please insert a MDOR state')
    if(mdorZipcode.length < 5 || mdorZipcode.length > 9 ) return notificationError('MDOR zipcode must have between 5 and 9 characters and only numbers')
    if (!form.mdorEmail || onlySpaces(form.mdorEmail)) return notificationError('Please insert a MDOR email')

    if (id) await createOrUpdateDistributor({ id, ...form })
    if (!id) await createOrUpdateDistributor(form)
    if (preview && image) await uploadDistributorImage({ id, image })
    history(-1)
  }

  return (
    <div className="new-distributor">
      <Head title={id ? 'Edit Distributor' : 'New Distributor'} />

      <div className="new-distributor__container">
        <Divider orientation="left"><strong>General info</strong></Divider>
        <div className="new-distributor__container">
          {preview && (
            <div style={{ width: '100px', marginBottom: '10px' }}>
              <img src={preview} style={{ width: '100%' }} />
            </div>
          )}
          {id && (
            <>
              <div style={{fontWeight: 'bold', marginBottom: 5}}>Logo Image</div>
              <div style={{ marginBottom: 10 }}>
                <input style={{ lineHeight: 'normal' }} accept="image/png, image/gif, image/jpeg" name="file" type="file" onChange={handleFileChange} />
              </div>
            </>

          )}

        </div>
        <div className="new-distributor__container__row">
          <Input
            label="Name*"
            placeholder="Name"
            value={form.name}
            onChange={(e: any) => setForm({ ...form, name: e.target.value })}
          />
          <Input
            label="Address*"
            placeholder="Address"
            value={form.address}
            onChange={(e: any) => setForm({ ...form, address: e.target.value })}
          />
          <Input
            label="Zipcode*"
            placeholder="Zipcode"
            value={form.zipcode}
            onChange={(e: any) => setForm({ ...form, zipcode: onlyNumbersAsString(e.target.value) })}
          />
          <Input
            label="City*"
            placeholder="City"
            value={form.city}
            onChange={(e: any) => setForm({ ...form, city: e.target.value })}
          />
          <Input
            label="State*"
            placeholder="State"
            value={form.state}
            onChange={(e: any) => e.target.value.length <= 2 && setForm({ ...form, state: e.target.value })}
            style={{ width: 100 }}
          />
          <Input
            onChange={(e) => setForm({ ...form, phone: e.target.value})}
            label='Phone*'
            placeholder='(000) 000-0000'
            value={form.phone || ''}
            inputMode={InputMode.PHONE}
          />
          <Input
            label="Emails (comma separated) *"
            placeholder="Emails"
            style={{ width: '440px' }}
            value={form.email}
            onChange={(e: any) => setForm({ ...form, email: e.target.value })}
          />
          <Radio
            innerProps={{ id: 'new-distributor-status' }}
            disabled={id ? true : false}
            label='Status*'
            value={form.status}
            onChange={(e: any) => setForm({ ...form, status: e.target.value })}
            options={statusSelectOptions}
          />
          <Input
            label="Pin code*"
            placeholder="Pin code"
            value={form.pinCode}
            onChange={(e: any) => setForm({ ...form, pinCode: e.target.value })}
          />
        </div>
        <Divider orientation="left"><strong>MDOR Export Settings</strong></Divider>
        <div className="new-distributor__container__row">
          <Input
            label="Business name*"
            placeholder="Business name"
            value={form.mdorBusinessName}
            onChange={(e: any) => setForm({ ...form, mdorBusinessName: e.target.value })}
          />
          <Input
            label="Etin*"
            placeholder="Etin"
            value={form.mdorEtin}
            onChange={(e: any) => setForm({ ...form, mdorEtin: e.target.value })}
          />
          <Input
            label="Fein*"
            placeholder="Fein"
            value={form.mdorFein}
            onChange={(e: any) => setForm({ ...form, mdorFein: e.target.value })}
          />
          <Input
            label="License Number *"
            placeholder="License Number"
            value={form.mdorLicenseNumber}
            onChange={(e: any) => setForm({ ...form, mdorLicenseNumber: e.target.value })}
          />
          <Input
            label="Permit ID *"
            placeholder="Permit ID"
            value={form.mdorPermitId}
            onChange={(e: any) => setForm({ ...form, mdorPermitId: e.target.value })}
          />
          <Input
            label="First Name *"
            placeholder="First Name"
            value={form.mdorContactFirstname}
            onChange={(e: any) => setForm({ ...form, mdorContactFirstname: e.target.value })}
          />
          <Input
            label="Last Name *"
            placeholder="Last Name"
            value={form.mdorContactLastname}
            onChange={(e: any) => setForm({ ...form, mdorContactLastname: e.target.value })}
          />
          <Input
            label="Title *"
            placeholder="Title"
            value={form.mdorContactTitle}
            onChange={(e: any) => e.target.value.length <= 16 && setForm({ ...form, mdorContactTitle: e.target.value })}
          />
          <Input
            onChange={(e) => setForm({ ...form, mdorContactPhone: e.target.value })}
            label='Phone*'
            placeholder='(000) 000-0000'
            value={form.mdorContactPhone || ""}
          />
          <Input
            label="Fax *"
            placeholder='(000) 000-0000'
            value={form.mdorContactFax || ""}
            onChange={(e: any) => setForm({ ...form, mdorContactFax: e.target.value })}
          />
          <Input
            label="Address Line 1*"
            placeholder="Address Line 1"
            value={form.mdorAddressLine1}
            onChange={(e: any) => setForm({ ...form, mdorAddressLine1: e.target.value })}
          />
          <Input
            label="Address Line 2*"
            placeholder="Address Line 2"
            value={form.mdorAddressLine2}
            onChange={(e: any) => setForm({ ...form, mdorAddressLine2: e.target.value })}
          />
          <Input
            label="City*"
            placeholder="City"
            value={form.mdorCity}
            onChange={(e: any) => setForm({ ...form, mdorCity: e.target.value })}
          />
          <Input
            label="State*"
            placeholder="State"
            value={form.mdorState}
            onChange={(e: any) => e.target.value.length <= 2 && setForm({ ...form, mdorState: e.target.value })}
          />
          <Input
            label="Zipcode*"
            placeholder="Zipcode"
            value={form.mdorZipcode}
            onChange={(e: any) => setForm({ ...form, mdorZipcode: onlyNumbersAsString(e.target.value) })}
          />
          <Input
            label="Email*"
            placeholder="Email"
            value={form.mdorEmail}
            onChange={(e: any) => setForm({ ...form, mdorEmail: e.target.value })}
          />
        </div>
        <Divider orientation="left"><strong>Deck Management Screen</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
            label="Allow Manufacturer To Configure Decks At Deck Management Screen"
            options={{ check: false, uncheck: true }}
            onChange={(e: any) => setForm({ ...form, disableDeckManagement: e })}
            value={form.disableDeckManagement}
          />
        </div>
        <Divider />
        <div className="new-distributor__container__actions">
          <CancelButton />
          <Button type="primary"
                  onClick={() => submit()}
                  disabled={!isChanged()}
          >
            <p id="save-button">Save</p>
          </Button>
        </div>
      </div>
      <p>* Indicates required fields</p>
    </div>
  )
}

export default NewDistributor